(function () {
    'use strict';

    angular
        .module('app')
        .factory('SMSService', SMSService);

    SMSService.$inject = [
        '$http',
        '$q',
        'UrlService'];

    function SMSService(
        $http,
        $q,
        UrlService) {
        var service = {};
        service.saveSMS = saveSMS;
        service.sendSMS = sendSMS;
        service.resendSMS = resendSMS;
        service.get = get;
        service.getValidationReport = getValidationReport;
        service.getPreview = getPreview;
        service.deleteSMS = deleteSMS;

        return service;

        /**
         * Save changes to an existing SMS.
         *
         * @returns {promise} - Resolves with an {object} of the updated SMS data,
         *   or rejects with a HTTP response including error info.
         */
        function saveSMS(smsData) {
            return $http.put(UrlService.getWebAPIUrl() + '/sms/' + smsData.Id, smsData)
                .then(function (response) {
                    return response.data;
                });
        }

        /**
         * POST SMS data to send the SMS
         *
         * @param {object} smsData - SMS data to be used for sending the SMS messages. Refer to the C# class 'SendSMSRequest'.
         *
         * @return returns the response data
         */
        function sendSMS(smsData) {
            return $http.post(UrlService.getWebAPIUrl() + '/sms/send', smsData)
                .then(function (response) {
                    // OK
                    return response.data;
                }, function (response) {
                    return $q.reject(response);
                });
        }

        /**
         * POST SMS id to resend the SMS
         *
         * @param {int} id - Id of SMS to be resent.
         *
         * @return returns the response data
         */
        function resendSMS(id) {
            return $http.post(UrlService.getWebAPIUrl() + '/sms/resend/' + id)
                .then(function (response) {
                    // OK
                    return response.data;
                }, function (response) {
                    return $q.reject(response);
                });
        }

        /**
         * GET the SMS with the specified id.
         */
        function get(id) {
            return $http.get(UrlService.getWebAPIUrl() + '/sms/' + id)
                .then(function (response) {
                    return response.data;
                }, function (response) {
                    return $q.reject(response);
                });
        }

        /**
         * POST SMS data to get a validation report for the SMS
         *
         * @param {object} smsData - SMS data to be used for validating the SMS messages. Refer to the C# class 'ValidateSMSRequest'.
         *
         * @return returns the response data
         */
        function getValidationReport(smsData) {
            return $http.post(UrlService.getWebAPIUrl() + '/sms/validate', smsData)
                .then(function (response) {
                    // OK
                    return response.data;
                }, function (response) {
                    return $q.reject(response);
                });
        }

        /**
         * Gets a 'preview' for the SMS, which is an SMS object with all of the send pre-processing conducted on the SMS.
         *
         * @param {object} sms - SMS object to populate with preview data.
         * @param {number} entityId - Preview should use the supplied entity for resolving merge fields. If not supplied the FromEntityId property will be used. Optional.
         * @returns {Promise} A promise which will resolve with an SMS object which can be used for showing a preview of the SMS with send pre-processing conducted.
         */
        function getPreview(sms, entityId) {
            var smsData = angular.copy(sms);
            
            if (!_.isNil(entityId) && entityId !== '') {
                smsData.FromEntityId = entityId;
            }

            return $http.post(UrlService.getWebAPIUrl() + '/sms/preview', smsData)
                .then(function (response) {
                    // OK
                    return response.data;
                });
        }

        /**
         * Delete the specified SMS.
         *
         * @param {number} smsId - Id of the SMS to delete.
         * @returns {promise}
         */
        function deleteSMS(smsId) {
            return $http.delete(UrlService.getWebAPIUrl() + '/sms/' + smsId);
        }
    }
})();